// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  padding: 5px;
  display: block;
}
ion-radio-group ion-item {
  background: #ffffff;
  border-radius: var(--radius-default);
  border: var(--outline-default);
}
ion-radio-group ion-item:not(:last-child) {
  margin-bottom: 5px;
}
ion-radio-group ion-item.selected {
  border: 1px solid var(--color-black);
}

.price {
  font-family: AppFontMedium;
  font-size: 16px;
  color: var(--color-grey);
  text-align: end;
}

ion-label {
  font-family: AppFontMedium;
  font-size: 16px;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

.pfand {
  font-size: 10px;
}

ion-checkbox {
  --checkmark-color: #fff;
  --border-color: #939393;
  --border-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACA,cAAA;AACD;AACC;EACC,mBAAA;EACA,oCAAA;EACA,8BAAA;AACF;AACE;EACC,kBAAA;AACH;AAEE;EACC,oCAAA;AAAH;;AASA;EACC,0BAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;AAND;;AASA;EACC,0BAAA;EACA,eAAA;AAND;;AASA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AAND;;AASA;EACC,qBAAA;AAND;;AASA;EACC,eAAA;AAND;;AASA;EACC,uBAAA;EACA,uBAAA;EACA,mBAAA;AAND","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tpadding: 5px;\n\tdisplay: block;\n\n\tion-item {\n\t\tbackground: #ffffff;\n\t\tborder-radius: var(--radius-default);\n\t\tborder: var(--outline-default);\n\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\n\t\t&.selected {\n\t\t\tborder: 1px solid var(--color-black);\n\t\t}\n\n\t\t// &:first-child {\n\t\t// \tborder-top: var(--outline-default);\n\t\t// }\n\t}\n}\n\n.price {\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tcolor: var(--color-grey);\n\ttext-align: end;\n}\n\nion-label {\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n}\n\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n\nion-checkbox {\n\t--checkmark-color: #fff;\n\t--border-color: #939393;\n\t--border-width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
